import { IconContent } from '@icons';

export const flag: IconContent = {
    sm: '<path fill-rule="evenodd" d="m11.98 3-1.837 1.8-.714.7.714.7L11.98 8 13 9H4v5H3V2h10l-1.02 1ZM8.729 6.214 10.55 8H4V3h6.55L8.73 4.786l-.73.714.73.714Z" />',
    md: '<path fill-rule="evenodd" d="m17.889 5-3.142 2.827L14 8.5l.747.673L17.89 12 19 13H6v7H5V4h14l-1.111 1ZM13.33 9.243 16.394 12H6V5h10.394l-3.063 2.757-.826.743.826.743Z" />',
};
